export default "__VITE_ASSET__BZqhkqFu__"